export enum SymRegions {
  TCTSI = 'TCTSI',
  TCTS5 = 'TCTS5',
}
